// src/index.js
import "./i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GOOGLE_MAPS_ENABLED } from "./config/googleMaps";

import { AuthProvider } from "./context/AuthContext";
import { ProfilePrefetchProvider } from "./context/ProfilePrefetchContext";
import { RegionalBackendProvider } from "./context/RegionalBackendContext";
import { BrowserRouter as Router } from "react-router-dom";
import { ConsentProvider } from "./context/ConsentContext";
import { FirstRunProvider } from "./context/FirstRunContext";
import { APP_VERSION, BUILD_DATE } from "./utils/version";

const Providers = ({ children }) => (
  <ConsentProvider>
    <AuthProvider>
      <RegionalBackendProvider>
        <Router>
          <ProfilePrefetchProvider>
            <FirstRunProvider>{children}</FirstRunProvider>
          </ProfilePrefetchProvider>
        </Router>
      </RegionalBackendProvider>
    </AuthProvider>
  </ConsentProvider>
);

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>,
);

if (process.env.NODE_ENV === "development") {
  console.info("[pdx-web-app] Development bundle booted.", {
    href: window.location.href,
    origin: window.location.origin,
    version: APP_VERSION,
    buildDate: BUILD_DATE,
    mapsKeyPresent: GOOGLE_MAPS_ENABLED,
    firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || null,
    regionalApiBaseUrl: process.env.REACT_APP_PDX_API_BASE_URL || null,
  });
  reportWebVitals(console.log);
} else {
  reportWebVitals();
}
